import config from '../config';
import { request } from '../utils/request';

const bemgrDomain = `${config.host}${config.apiRouter.bemgr}`;

const api = {
  getBackendAppList (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetAppList`,
      data,
    });
  },
  createBackendApp (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/CreateApp`,
      data,
    });
  },
  updateBackendApp (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/UpdateApp`,
      data,
    });
  },
  getBackendAppDetail (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetAppDetail`,
      data,
    });
  },

  // service
  getBackendAppServiceList (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetServiceListInApp`,
      data,
    });
  },

  // 获取应用下已申请的第三方服务列表
  getBackendThirdAppServiceListInApp (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetServiceSubscriptionListInApp`,
      data,
    });
  },

  // 获取公开服务列表
  getBackendPublicThirdServiceListInApp (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetPublicServiceListInApp`,
      data,
    });
  },

  // 申请第三方服务
  applyBackendThirdAppService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/SubscribeService`,
      data,
    });
  },

  createBackendService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/CreateService`,
      data,
    });
  },

  updateBackendService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/UpdateService`,
      data,
    });
  },

  // 删除应用下已申请的第三方服务
  delBackendThirdAppServiceList (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/DeleteServiceSubscription`,
      data,
    });
  },

  getBackendAppServiceDetail (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetServiceDetail`,
      data,
    });
  },

  // 获取第三方服务授权列表
  getThirdServiceAuthList (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetServiceSubscriptionAuthorizationListInSystem`,
      data,
    });
  },

  // 获取某一应用下的待审核服务列表
  getServiceAuthList (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetServiceListInSys`,
      data,
    });
  },

  // 驳回服务
  serviceReject (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/RejectPublishingService`,
      data,
    });
  },

  // 禁用服务（或解禁）
  disableService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/DisableService`,
      data,
    });
  },

  // 冻结服务（或解冻）
  freezeService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/FreezeService`,
      data,
    });
  },

  // 同意服务
  servicePublish (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/PublishService`,
      data,
    });
  },

  // 同意第三方服务申请
  agreeThirdService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/ApproveSubscribingService`,
      data,
    });
  },

  // 拒绝第三方服务申请
  rejectThirdService (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/RejectSubscribingService`,
      data,
    });
  },

  // 获取某系统下供应商列表
  getVendorListInSystem (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetVendorListInSystem`,
      data,
    });
  },

  // 获取某系统下机构列表
  getOrgInSystem (data) {
    return request({
      method: 'POST',
      url: `${bemgrDomain}/GetOrgInSystem`,
      data,
    });
  },
};
export default api;
